import moment from "moment";

const initialState = {
    list: [],
    blockFiscal: false,
    detail: null,
    paging: {
      start: 0,
      limit: 10,
      localLimit: localStorage.getItem('ordersPageLimit') ? localStorage.getItem('ordersPageLimit') : 10,
    },
    sorting: {
      field: 'id',
      type: 'desc'
    },
    filters: {
      city: null,
      cities: [],
      point: null,
      points: [],
      status: null,
      statuses: [],
      createdStartDate: null,
      createdEndDate: null,
      payment: null,
      id: null,
      phone: null
    },
    count: 0
};

const getOrderTime = (order) => {
  const time = parseInt(order.timeZone, 10) || 3;
  const baseOrderDate = order.visible_datetime || order.created_at;
  return moment.utc(baseOrderDate).add(time, 'hours').format('DD.MM.YYYY HH:mm').valueOf();
}

export default function orders(state = initialState, action) {
  switch(action.type) {
    case 'SET_ORDERS': {
          return {
              ...state,
              list: action.orders
          };
    }
    case 'SET_ORDERS_FILTERS': {
      return {
          ...state,
          filters: action.filters
      };
    }
    case 'SET_ORDERS_PAGING': {
      return {
          ...state,
          paging: action.paging
      };
    }
    case 'SET_ORDERS_COUNT': {
      return {
          ...state,
          count: action.count
      };
    }
    case 'SET_ORDER': {
      return {
          ...state,
          detail: action.order
      };
    }
    case 'UPDATE_ORDER_TABLE': {
      return {
          ...state,
          list: state.list.map(el =>
              el.id === action.id
                  ? {
                      ...el,
                      ...action.data,
                    }
                  : el
          )
      };
    }
    case 'ADD_NEW_ORDER': {
      const orderExists = state.list.some(order => order.id === action.order.id);
      if (orderExists) {
        return state;
      }
      const normalizedOrder = {
        ...action.order,
        goods: Array.isArray(action.order && action.order.goods) ? action.order.goods : []
      };

      const newList = [normalizedOrder, ...state.list];
      newList.sort((a, b) => getOrderTime(b) - getOrderTime(a));
      
      return {
          ...state,
          list: newList,
          count: state.count + 1
      };
    }
    case 'REMOVE_ORDER_FROM_LIST': {
      return {
        ...state,
        list: state.list.filter(order => order.id !== action.orderId),
        count: Math.max(0, state.count - 1)
      };
    }
    case 'SET_FISCAL_DATA_ORDER': {
      return {
        ...state,
        list: state.list.map(el =>
            el.id === action.data.id
                ? {
                    ...el,
                    fiscalUUID: action.data.fiscalUUID,
                    fiscalized: action.data.fiscalized,
                  }
                : el
        )
      };
    }
    case 'SET_BLOCK_FISCAL': {
      return {
        ...state,
        blockFiscal: action.value,
      }
    }
    default: return state;
    }
}